import React, { useState } from 'react';
import { InputAdornment, TextField, Tooltip, IconButton } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { Search as SearchIcon } from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate } from 'react-router-dom';
import HistoryIcon from '@mui/icons-material/History';
import DialogHistory from '../../components/DialogHistory';
import { getAllHistoryEvent } from '../../repositories/HttpRepository';
import { AxlButton } from 'components/AxlButton';
import { lightTheme } from '@gojitsu/web-ui-core';

const useStyles = makeStyles()((theme) => ({
  searchForm: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    display: 'flex',
  },
  searchInput: {
    flexGrow: 2,
    backgroundColor: '#fff',
    '&>.MuiInputBase-root': {
      fontSize: 14,
      '&>.MuiOutlinedInput-input': {
        paddingTop: '12px',
        paddingBottom: '12px',
      },
    },
  },

  searchBtn: {
    width: 150,
    marginRight: 20,
    height: 40,
    borderRadius: 3,
    backgroundColor: lightTheme.palette.secondary.main,
    color: 'rgb(255, 255, 255)',
    fontSize: '15px',
    fontWeight: 600,
    border: 'none',
    cursor: 'pointer',
    outline: 'none',
  },
  closeBtn: {
    padding: 8,
  },
  select: {
    width: 180,
  },
  btnHistory: {
    marginLeft: '20px',
  },
}));

const SearchForm = ({ onSubmit, reset, isDesc, defaultKeyword }) => {
  const [keyword, setKeyword] = useState(defaultKeyword || '');
  const [openHistory, setOpenHistory] = useState(false);
  const [events, setEvents] = useState([]);

  const { classes } = useStyles();
  const navigate = useNavigate();

  const addAction = (e) => {
    e.preventDefault();
    navigate('/prefixes-management/add', { state: { is_desc: isDesc } });
  };

  function handleChangeSearch(e) {
    if (!onSubmit) return;
    setKeyword(e.target.value.toUpperCase());

    if (e.target.value === '') {
      return reset(e);
    }
  }

  function handleResetSearch(e) {
    if (!reset) return;

    setKeyword('');
    reset(e);
  }

  function handleKeyDown(e) {
    if (e.key === 'Enter') {
      onSubmit(e.target.value);
      e.preventDefault();
    }
  }

  const handleShowAllHistory = (e) => {
    e.preventDefault();
    setOpenHistory(true);
  };

  const handleCloseHistory = (e) => {
    setOpenHistory(false);
  };

  return (
    <>
      <form className={classes.searchForm} noValidate autoComplete="off">
        <AxlButton variant="contained" color="primary" className={classes.searchBtn} onClick={addAction}>
          + NEW
        </AxlButton>
        <TextField
          onChange={handleChangeSearch}
          onKeyDown={handleKeyDown}
          variant="outlined"
          id="standard-start-adornment"
          value={keyword}
          className={classes.searchInput}
          placeholder="Search for prefix by prefix name"
          slotProps={{
            input: {
              startAdornment: (
                <InputAdornment className={classes.searchIcon} position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
              endAdornment: keyword && (
                <IconButton className={classes.closeBtn} onClick={() => handleResetSearch()} size="large">
                  <CloseIcon />
                </IconButton>
              ),
            },
          }}
        />

        <Tooltip title="View all deleted prefixes history">
          <AxlButton variant="contained" color="secondary" className={classes.btnHistory} onClick={handleShowAllHistory}>
            <HistoryIcon />
          </AxlButton>
        </Tooltip>
      </form>
      <DialogHistory getEvents={getAllHistoryEvent} open={openHistory} handleClose={handleCloseHistory} title={'View all deleted prefixes history'} />
    </>
  );
};
export default React.memo(SearchForm);
